
import { BrowserRouter } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import routes from './router/config';
import { useEffect } from 'react';

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics if not already done
    if (typeof gtag !== 'undefined') {
      gtag('config', 'G-W0PQY6HR8Z', {
        page_title: document.title,
        page_location: window.location.href
      });
    }
  }, []);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
